import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header d-flex justify-content-end pb-4" }
const _hoisted_3 = { class: "card-title d-flex align-items-center gap-4" }
const _hoisted_4 = { class: "d-flex align-items-center gap-2" }
const _hoisted_5 = { class: "fs-7 text-gray-600" }
const _hoisted_6 = { class: "d-flex align-items-center gap-2" }
const _hoisted_7 = { class: "fs-7 text-gray-600" }
const _hoisted_8 = { class: "d-flex align-items-center gap-2" }
const _hoisted_9 = { class: "fs-7 text-gray-600" }
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = { class: "fs-1 mb-3" }

import { ref } from "vue";
import BriefDetailTradeStat from "@/projects/tenant/modules/trade/modals/BriefDetailTradeStat.vue";
import { ServiceTypes } from "@/core/types/ServiceTypes";
import { CurrencyTypes } from "@/core/types/CurrencyTypes";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountBriefDetail',
  props: {
    accountDetails: {}
  },
  setup(__props: any) {

const props = __props;



const currencyOptions = [
  CurrencyTypes.USD,
  CurrencyTypes.USC,
  CurrencyTypes.AUD,
  CurrencyTypes.JPY,
];

const serviceId = ref<number>(ServiceTypes.MetaTrader4);
const multiLevel = ref<boolean>(true);
const currencyId = ref<number>(CurrencyTypes.USD);
const appliedServiceId = ref<number>(serviceId.value);
const appliedMultiLevel = ref<boolean>(multiLevel.value);
const appliedCurrencyId = ref<number>(currencyId.value);

const today = new Date();

const formatDate = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

const defaultPeriod = (): string[] => [
  formatDate(
    new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
  ),
  formatDate(
    new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
  ),
];

const period = ref<string[]>(defaultPeriod());
const modifiedPeriod = ref<string[]>(defaultPeriod());

const handleDateChange = () => {
  if (!period.value || !period.value[1]) {
    modifiedPeriod.value = period.value ? [...period.value] : [];
    return;
  }
  const endDate = new Date(period.value[1]);
  endDate.setHours(23, 59, 59, 999);
  period.value[1] = formatDate(endDate);

  modifiedPeriod.value = [...period.value];
};

const search = () => {
  appliedServiceId.value = serviceId.value;
  appliedMultiLevel.value = multiLevel.value;
  appliedCurrencyId.value = currencyId.value;
  handleDateChange();
};

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("fields.platform")), 1),
          _createVNode(_component_el_select, {
            modelValue: serviceId.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((serviceId).value = $event)),
            placeholder: _ctx.$t('fields.platform'),
            class: "w-100px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: _ctx.$t('type.platform.20'),
                value: _unref(ServiceTypes).MetaTrader4
              }, null, 8, ["label", "value"]),
              _createVNode(_component_el_option, {
                label: _ctx.$t('type.platform.30'),
                value: _unref(ServiceTypes).MetaTrader5
              }, null, 8, ["label", "value"])
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("fields.multiLevel")), 1),
          _createVNode(_component_el_select, {
            modelValue: multiLevel.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((multiLevel).value = $event)),
            placeholder: _ctx.$t('fields.multiLevel'),
            class: "w-80px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: _ctx.$t('fields.yes'),
                value: true
              }, null, 8, ["label"]),
              _createVNode(_component_el_option, {
                label: _ctx.$t('fields.no'),
                value: false
              }, null, 8, ["label"])
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("fields.currency")), 1),
          _createVNode(_component_el_select, {
            modelValue: currencyId.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currencyId).value = $event)),
            placeholder: _ctx.$t('fields.currency'),
            class: "w-120px"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(currencyOptions, (item) => {
                return _createVNode(_component_el_option, {
                  key: item,
                  label: _ctx.$t(`type.currency.${item}`),
                  value: item
                }, null, 8, ["label", "value"])
              }), 64))
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder"])
        ]),
        _createVNode(_component_el_date_picker, {
          modelValue: period.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((period).value = $event)),
          type: "datetimerange",
          "start-placeholder": "Start date",
          "end-placeholder": "End date",
          "range-separator": "-",
          "value-format": "YYYY-MM-DD HH:mm:ss"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_button, {
          type: "success",
          plain: "",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (search())),
          class: "ms-4"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.search")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, _toDisplayString(props.accountDetails.name), 1),
      _createVNode(BriefDetailTradeStat, {
        accountId: props.accountDetails.id,
        name: props.accountDetails.name,
        byAccountId: true,
        multiLevel: appliedMultiLevel.value,
        serviceId: appliedServiceId.value,
        currencyId: appliedCurrencyId.value,
        period: modifiedPeriod.value
      }, null, 8, ["accountId", "name", "multiLevel", "serviceId", "currencyId", "period"])
    ])
  ]))
}
}

})